import { defineComponent, ref } from '@vue/composition-api';

export const statusGroups = [
  {
    key: 'source',
    statuses: [
      { status: 'available', description: 'available' },
      { status: 'withdrawn', description: 'withdrawn' },
      { status: 'expired', description: 'expired' },
    ],
  },
  {
    key: 'evaluation',
    statuses: [
      { status: 'pending', description: 'evaluation-pending' },
      { status: 'eligible', description: 'eligible' },
      { status: 'incomplete', description: 'incomplete' },
      { status: 'excluded', description: 'excluded' },
      { status: 'configuration-error', description: 'configuration-error' },
    ],
  },
  {
    key: 'approval',
    statuses: [
      { status: 'review-required', description: 'review-required' },
      { status: 'approval-pending', description: 'approval-pending' },
      { status: 'approved', description: 'approved' },
      { status: 'rejected', description: 'rejected' },
      { status: 'not-required', description: 'not-required' },
    ],
  },
  {
    key: 'processing',
    statuses: [
      { status: 'pending', description: 'processing-pending' },
      { status: 'processing', description: 'processing' },
      { status: 'draft', description: 'draft' },
      { status: 'published', description: 'published' },
      { status: 'failed', description: 'failed' },
    ],
  },
];

export default defineComponent({
  setup() {
    const dialog = ref<HTMLDialogElement | null>(null);
    const open = () => dialog.value?.showModal();
    const close = () => dialog.value?.close();

    return { dialog, open, close, statusGroups };
  },
});
